// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.freemium.RentalManagerUserFreemiumWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserFreemiumWebApiHandler_charge,
  RentalManagerUserFreemiumWebApiHandler_details,
  RentalManagerUserFreemiumWebApiHandler_details_Path,
  RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible,
  RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Path,
  RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  FreemiumChargeResponseWebDto,
  FreemiumDetailsResponseWebDto,
  FreemiumStartPaymentMethodSessionResponseWebDto,
  ListingAlias,
  RentalManagerPaymentProductType,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ChargeParams {
  hostApp?: string;
  listingAlias: ListingAlias;
  productType: RentalManagerPaymentProductType;
}
interface DetailsParams {
  listingAlias: ListingAlias;
}
interface StartPaymentMethodSessionParams {
  hostApp?: string;
  listingAlias: ListingAlias;
}

export interface RentalManagerUserFreemiumWebApiHandler_charge_Args {
  getParams: ChargeParams;
}

export type RentalManagerUserFreemiumWebApiHandler_charge_Options = UseMutationOptions<
  FreemiumChargeResponseWebDto,
  unknown,
  RentalManagerUserFreemiumWebApiHandler_charge_Args
>;

/**
 * Charge credit card
 */
export const useRentalManagerUserFreemiumWebApiHandler_charge = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFreemiumWebApiHandler_charge_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFreemiumWebApiHandler_charge_Args) =>
      RentalManagerUserFreemiumWebApiHandler_charge(args.getParams, httpClient),
  });
};

export type RentalManagerUserFreemiumWebApiHandler_details_Options = UseQueryOptions<
  FreemiumDetailsResponseWebDto,
  unknown,
  FreemiumDetailsResponseWebDto,
  readonly [string, DetailsParams]
>;

const RentalManagerUserFreemiumWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [RentalManagerUserFreemiumWebApiHandler_details_Path, getParams] as const;

export const RentalManagerUserFreemiumWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumWebApiHandler_details_GetKey(getParams),
    queryFn: () => RentalManagerUserFreemiumWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get freemium details for a listing
 */
export const useRentalManagerUserFreemiumWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFreemiumWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFreemiumWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumWebApiHandler_details.getKey = RentalManagerUserFreemiumWebApiHandler_details_GetKey;

export type RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string]
>;

const RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_GetKey = () =>
  [RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Path] as const;

export const RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_GetKey(),
    queryFn: () => RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get user's eligibility for top of funnel enrollment
 */
export const useRentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible.getKey =
  RentalManagerUserFreemiumWebApiHandler_isTopOfFunnelEnrollmentEligible_GetKey;

export interface RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession_Args {
  getParams: StartPaymentMethodSessionParams;
}

export type RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession_Options = UseMutationOptions<
  FreemiumStartPaymentMethodSessionResponseWebDto,
  unknown,
  RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession_Args
>;

/**
 * Start payment method session to load the credit card iframe
 */
export const useRentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession_Args) =>
      RentalManagerUserFreemiumWebApiHandler_startPaymentMethodSession(args.getParams, httpClient),
  });
};
